import React, { useEffect, useState } from "react";
import ListingCard from "./ListingCard";
import { useSelector } from "react-redux";
import { useTranslation } from 'react-i18next';
import "./listingCard.css"
import { useSearchParams } from "react-router-dom";

export const SearchListing = ({ searchResults, onPageChange, listingHeader,currentPage, setCurrentPage }) => {
  const { t } = useTranslation();

  const [searchData, setSearchData] = useState([]);
  const [totalResults, setTotalResults] = useState(0);
  const [pages, setPages] = useState([]);
  // const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const url = window.location.href;
  const slug = url.split('?')[0].split('/').pop();
  const [searchParams] = useSearchParams();

  const sliceName = slug === "search" ? "searchLanding" : slug.includes("search-support") ? "supportSearch" : "";
  const isLoading = useSelector((state) => state[sliceName]?.search?.isLoading);


 useEffect(() => {
    if (searchResults && searchResults?.docs?.length > 0) {
      const total = searchResults.total;
      const pagesCount = Math.ceil(total / 5);
      setTotalResults(total);
      setTotalPages(pagesCount);

      const maxPagesToShow = 5;
      let startPage = Math.max(1, currentPage - Math.floor(maxPagesToShow / 2));
      let endPage = Math.min(pagesCount, startPage + maxPagesToShow - 1);

      if (endPage - startPage + 1 < maxPagesToShow) {
        startPage = Math.max(1, endPage - maxPagesToShow + 1);
      }

      const newPages = [];
      for (let i = startPage; i <= endPage; i++) {
        newPages.push(
          <li key={i}>
            <button
              className={`sd-py-1 sd-px-2 ${currentPage === i ? 'sd-bg-black sd-text-white' : 'sd-bg-white sd-text-black'} sd-rounded-sm hover:sd-bg-black hover:sd-text-white ${pagesCount === 1 ? 'sd-mx-5' : ''}`}
              onClick={() => handlePageClick(i)}
            >
              {i}
            </button>
          </li>
        );
      }
      if (endPage < pagesCount) {
        newPages.push(
          <li key="ellipsis">
            <button className="sd-py-1 sd-px-2 sd-text-gray-300 sd-rounded-sm hover:sd-bg-black hover:sd-text-white">
              ...
            </button>
          </li>
        );
      }
      setPages(newPages);
      setSearchData(searchResults.docs);
    } else {
      setSearchData([]);
      setTotalResults(0);
      setTotalPages(1);
      setPages([]);
      setCurrentPage(1);
    }
  }, [searchResults, currentPage]);

  const handlePrev = () => {
    if (currentPage > 1) {
      const newPage = currentPage - 1;
      setCurrentPage(newPage);
      onPageChange(newPage);
      handlePageClick(newPage);
    }
  };

  const handleNext = () => {
    if (currentPage < totalPages) {
      const newPage = currentPage + 1;
      setCurrentPage(newPage);
      onPageChange(newPage);
      handlePageClick(newPage);
    }
  };

  const handlePageClick = (pageNumber) => {
    //move focus to div id searchResultContainer
    const searchResultContainer = document.getElementById("searchResultContainer");
    if (searchResultContainer) {
      searchResultContainer.scrollIntoView({ behavior: "smooth" });
    }

    setCurrentPage(pageNumber);
    onPageChange(pageNumber);
  };

  return (
    <React.Fragment>
      <div className="sd-col-span-8 lg:sd-col-span-12 lg:sd-col-start-5 lg:sd-pl-0" id="searchResultContainer">
        <div className="col-sm-12"  >
          <div className="search-results-container sd-mt-10">
            {searchResults && searchResults?.docs?.length > 0 &&  (
              <h2 className="sd-uppercase sd-text-[13px] sd-titleText lg:sd-my-[52px] sd-my-[88px]">
                {listingHeader ? `${listingHeader} ` : `${t("searchResult")} `} [<span id="totalResults">{totalResults}</span>]
              </h2>
            ) }
            <ul 
            id="searchResultContainerDiv" 
            className="search-results sd-list-group sd-pl-0"
            >
              {isLoading ? (
                <>
                  {[...Array(5)].map((_, index) => (
                    <li key={index} className="sd-cols-span-14 sm:sd-cols-span-10 sm:sd-offs-1 sd-list-reset">
                      <article className="sd-mb-[2vh]">
                        <div className="sd-text-gray-4 sd-mb-4">
                          <div className="sd-skeleton sd-mb-2" style={{ width: '100%', height: '5vh' }}></div>
                          <div className="sd-skeleton sd-mb-2" style={{ width: '100%', height: '5vh' }}></div>
                        </div>
                        <h3 className="sd-mb-1">
                          <div className="sd-skeleton" style={{ width: '100%', height: '5vh' }}></div>
                        </h3>
                      </article>
                    </li>
                  ))}
                </>
              ) : (
                searchData?.length > 0 &&
                searchData.map((docs, index) => (
                  <ListingCard data={docs} key={index + "sd-card"} />
                ))
              )}
            </ul>
            {(searchData?.length > 2 || currentPage > 1) && (
              <div className="sd-pagination-container sd-flex sd-items-baseline sd-justify-center sd-mb-10">
                <button disabled={currentPage === 1}
                  className={`sd-py-1 sd-px-2 ${currentPage === 1 ? 'sd-pointer-events-none sd-text-gray-300' : 'sd-text-black'} sd-bg-white sd-rounded-sm active:sd-bg-black active:sd-text-white`}
                  onClick={handlePrev}
                >
                  {t('previous')}
                </button>
                <ul className="sd-flex sd-space-x-3 sd-items-center">{pages}</ul>
                <button
                  disabled={currentPage === totalPages}
                  className={`sd-py-1 sd-px-2 ${currentPage === totalPages ? 'sd-pointer-events-none sd-text-gray-300' : ''} sd-bg-white sd-text-black sd-rounded-sm hover:sd-bg-black hover:sd-text-white`}
                  onClick={handleNext}
                >
                  {t('next')}
                </button>
              </div>
            )}
            
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default SearchListing;
